import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BriaButton from "../../components/common/BriaButton/BriaButton.tsx";
import RouterConstants from "../../constants/RouterConstants.ts";
import { ORG_SUBSCRIPTION_PLANS } from "../../constants/billing.ts";
import { useAppStore } from "../../hooks/useStores.tsx";
import { hasOrganization } from "../../utils";
import AttributionWidget from "./Attribution/AttributionWidget";
import ContactWidget from "./Contact/ContactWidget";
import styles from "./Dashboard.module.scss";
import LearningHubWidget from "./LearningHub/LearningHubWidget";
import LegalWidget from "./Legal/LegalWidget";
import ProductsWidget from "./Products/ProductsWidget";
import UsageWidget from "./Usage/UsageWidget";

const Dashboard = () => {
	const { t } = useTranslation("dashboard");
	const { authStore } = useAppStore();
	const navigate = useNavigate();
	const isPayingOrg = authStore.orgSubscription?.plan_name !== ORG_SUBSCRIPTION_PLANS.free.name;
	const welcomeKey = authStore.isFirstLogin ? "header.titleNew" : "header.title";

	return (
		<Box className={styles.content}>
			<Box className={styles.header}>
				<Typography className={styles.title}>
					{t(welcomeKey, { userName: authStore.user?.userName })}
				</Typography>
				<Trans>
					<Typography className={styles.description}>{t("header.description")}</Typography>
				</Trans>
				{!hasOrganization() && (
					<Box className={styles.freeTrial}>
						<Typography className={styles.freeTrialTitle}>
							<span className={styles.freeTrialSecondary}>{t("header.freeTrial.title")}</span>
							<span className={styles.freeTrialHighlight}>{t("header.freeTrial.highlight")}</span>
						</Typography>
						<BriaButton
							buttonType="primaryMedium"
							className={styles.apiBtn}
							onClick={() => navigate(RouterConstants.AUTH_KEYS.fullPath)}
						>
							{t("header.freeTrial.button")}
						</BriaButton>
					</Box>
				)}
			</Box>
			<Box className={styles.dashboardGrid}>
				<Box className={styles.row}>
					<ProductsWidget className={styles.products} />
					{hasOrganization() && <UsageWidget className={styles.usage} />}
				</Box>
				<Box className={styles.row}>
					<Box className={styles.stacked}>
						{hasOrganization() && isPayingOrg ? (
							<AttributionWidget className={styles.attribution} />
						) : (
							<LegalWidget />
						)}
						<ContactWidget className={styles.contact} />
					</Box>
					<LearningHubWidget className={styles.learningHub} />
				</Box>
			</Box>
		</Box>
	);
};

export default observer(Dashboard);
